import React from 'react';
import {
    Navbar,
    Nav,
    NavItem,
    Button,
} from 'reactstrap';
import SystemLabel from '../../system/SystemLabel/SystemLabel';

export default class ArchiveHeader extends React.Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            isOpen: false,
            isCopied: false
        };
    }
    copyLink = () => {
        
        navigator.clipboard.writeText(this.props.selectedFile.url?.replace(/ /g, '%20'))
        this.setState({ isCopied: true }, () => {
            setTimeout(() => {
                this.setState({ isCopied: false })
            }, 3000)
        })
    }
    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    render() {
        const { onUpload, selectedFile, onUseSelected, crop, onDelete, fontEnabled } = this.props;

        return (
            <div>
                <Navbar light expand="md">
                    < Nav navbar>
                        <NavItem>
                            <label htmlFor="file-upload" className="archive-toolbar-btn">
                                <i className="fa fa-upload"></i>{"  "}
                                <SystemLabel name="Upload" />
                            </label>
                            <input id="file-upload" className="file-upload" type="file" /* multiple */ onChange={(e) => onUpload(e)} />
                        </NavItem>
                        {selectedFile && selectedFile.type.includes('image/') && fontEnabled === false}
                        {/*    {fontEnabled} */}
                        {(selectedFile !== null && selectedFile.type.includes('image/') && fontEnabled === false) && <NavItem>
                            <Button className="archive-toolbar-btn avoid-style-leak" onClick={() => onUseSelected()}>
                                <i className="fa fa-check"></i>{"  "}
                                <SystemLabel name="Select" />
                            </Button>
                        </NavItem>}
                        {(selectedFile !== null && selectedFile.type.includes('font/') && fontEnabled === true) && <NavItem>
                            <Button className="archive-toolbar-btn avoid-style-leak" onClick={() => onUseSelected()}>
                                <i className="fa fa-check"></i>{"  "}
                                <SystemLabel name="Select" />
                            </Button>
                        </NavItem>}
                      
                        {selectedFile && <NavItem>
                            <Button className="archive-toolbar-btn avoid-style-leak" onClick={() => onDelete()}>
                                <i className="fa fa-trash"></i>{"  "}
                                <SystemLabel name="Delete" />
                            </Button>
                        </NavItem>}
                        {/* ADD A TYPE CHECK LATER */}
                        {/* {selectedFile && selectedFile.type.includes('image/') && <NavItem>
                            <Button className="archive-toolbar-btn avoid-style-leak" onClick={() => crop()}>
                                <i className="fa fa-crop"></i>{"  "}
                                <SystemLabel name="CropImage" />
                            </Button>
                        </NavItem>} */}
                        {selectedFile !== null ? <NavItem>
                            <Button className="archive-toolbar-btn avoid-style-leak" onClick={() => this.copyLink()}>
                                {this.state.isCopied ? <i className="fa fa-check-circle" /> : <i className="fa fa-copy"></i>}{"  "}
                                {this.state.isCopied ? <SystemLabel name="IsCopied" /> : <SystemLabel name="CopyLink" />}
                            </Button>
                        </NavItem> : null}
                    </Nav>
                </Navbar>
            </div >
        );
    }
}
